import { render, staticRenderFns } from "./reforco.vue?vue&type=template&id=3c0641b2"
import script from "./reforco.ts?vue&type=script&lang=js&external"
export * from "./reforco.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0641b2')) {
      api.createRecord('3c0641b2', component.options)
    } else {
      api.reload('3c0641b2', component.options)
    }
    module.hot.accept("./reforco.vue?vue&type=template&id=3c0641b2", function () {
      api.rerender('3c0641b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/sessaoCaixa/reforco.vue"
export default component.exports